import { useCallback, useRef, useState } from 'react';
import { StyledImg } from './Img.styled';
import { SteeringWheelPresets } from './SettingVehicleSteering.model';

interface ISettingVehicleSteeringProps {
	onChange?: (newValue: number) => void;
}

const SettingVehicleSteering: React.FC<ISettingVehicleSteeringProps> = ({
	onChange,
}) => {
	const [presetIndex, setPresetIndex] = useState(0);

	const imageRef = useRef<HTMLImageElement>(null);

	const handleClick = useCallback(() => {
		if (!imageRef.current) {
			return;
		}

		const newPresetIndex = (presetIndex + 1) % SteeringWheelPresets.length;
		setPresetIndex(newPresetIndex);

		const newValue = SteeringWheelPresets[newPresetIndex];
		imageRef.current.style.transform = `rotate(${newValue}deg)`;

		onChange?.(newValue);
	}, [presetIndex]);

	return <StyledImg ref={imageRef} onClick={handleClick} />;
};

export { SettingVehicleSteering };
